import { render, staticRenderFns } from "./CompanionMyStock.vue?vue&type=template&id=765773de&scoped=true&"
var script = {}
import style0 from "./CompanionMyStock.vue?vue&type=style&index=0&id=765773de&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765773de",
  null
  
)

export default component.exports